<template>
  <!-- 多选题 -->
  <yxt-form
    ref="ruleForm"
    :model="currentComponent"
    :rules="rules"
    label-width="100px"
    isNeedRequire
    isNeedTooltip
    label-position="top"
  >
    <yxt-form-item
      :label="$t('pc_biz_ote_lbl_questionstem')"
      :rules="rulesContent"
      :prop="'content'"
      size="small"
    >
      <common-attachment-textfield
        :content.sync="currentComponent.content"
        single-limit
      />
    </yxt-form-item>
    <yxt-form-item
      size="small"
      :label="$t('pc_biz_ote_lbl_options')"
      class="mb0"
    >
    </yxt-form-item>
    <draggable
      v-model="currentComponent.questionItems"
      handle=".moverHandle"
      chosenClass="yxtbiz-ote-chosen-item"
      :move="onMoveTarget"
      @start="onStartTarget"
      @clone="onCloneTarget"
      @end="onEndTarget"
    >
      <yxt-form-item
        v-for="(item, index2) in currentComponent.questionItems"
        :key="item.id"
        :rules="rulesItem"
        :prop="'questionItems.' + index2 + '.itemContent'"
        class="yxtbiz-ote-edit-ques-option"
        size="small"
      >
        <div class="flex flex-mid wp-100">
          <div class="moverHandle flex flex-mid mr8">
            <yxt-svg
              :remote-url="SvgMediaNewUrl"
              width="16px"
              height="16px"
              class="color-gray-7"
              icon-class="ai-drag-cc"
            ></yxt-svg>
          </div>
          <div class="mr8 min-w-16 text-center">
            {{ convertASCII(index2) }}
          </div>
          <common-attachment-textfield
            class="flex-g-1"
            :auto-focus="focusIndex === index2"
            :content.sync="item.itemContent"
            single-limit
          />
          <yxt-tooltip :content="$t('pc_biz_ote_btn_delete')" placement="top">
            <div class="yxtbiz-ote-ai-icon hand ml12" @click="delItem(index2)">
              <yxt-svg width="16px" height="16px" icon-class="delete" />
            </div>
          </yxt-tooltip>
        </div>
      </yxt-form-item>
    </draggable>
    <!-- 添加选项 -->
    <div class="mb24">
      <yxt-button
        type="text"
        @click="addItem()"
        :disabled="
          currentComponent.questionItems &&
          currentComponent.questionItems.length >= 12
        "
      >
        <div class="ml48 flex flex-mid">
          <yxt-svg
            width="16px"
            height="16px"
            class="mr4"
            icon-class="common_plus"
          ></yxt-svg>
          <span>{{ $t('pc_biz_ote_btn_additem') }}</span>
        </div>
      </yxt-button>
    </div>
    <yxt-form-item
      :label="$t('pc_biz_ote_lbl_itemanswer')"
      prop="answer"
      size="small"
    >
      <yxt-checkbox-group
        v-model="currentComponent.answer"
        @change="radioChange"
      >
        <yxt-checkbox
          v-for="(item, index) in currentComponent.questionItems"
          :key="item.id"
          :label="item.id"
          name="type"
        >
          {{ convertASCII(index) }}
        </yxt-checkbox>
      </yxt-checkbox-group>
    </yxt-form-item>
    <yxt-form-item
      :label="$t('pc_biz_ote_lbl_quesanalyze')"
      size="small"
      prop="explainText"
    >
      <common-attachment-textfield
        :content.sync="currentComponent.explainText"
        single-limit
      />
    </yxt-form-item>
  </yxt-form>
</template>

<script>
import { quesMixin } from './quesMixin';
import draggable from 'vuedraggable';
import CommonAttachmentTextfield from './components/CommonAttachmentTextfield.vue';
import { getSafeHtmlContent } from '../../utils';
import { SvgMediaUrl, SvgMediaNewUrl } from '../../const';
export default {
  name: 'quesCheckbox',
  mixins: [quesMixin],
  components: {
    draggable,
    CommonAttachmentTextfield
  },
  data() {
    return {
      SvgMediaUrl,
      SvgMediaNewUrl,
      rulesContent: {
        required: true,
        message: this.$t('pc_biz_ote_msg_pleaseenterquestion'),
        trigger: 'blur'
      },
      rulesItem: {
        required: true,
        message: this.$t('pc_biz_ote_msg_pleaseenteroption'),
        trigger: 'blur'
      },
      rules: {
        answer: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (
                !this.currentComponent.answer ||
                this.currentComponent.answer.length === 0
              ) {
                callback(new Error(this.$t('pc_biz_ote_msg_itemanswer')));
              } else {
                callback();
              }
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    radioChange() {
      this.$forceUpdate();
    },
    // 保存试题基本信息
    saveDetail() {
      let isSave = false;
      this.$refs.ruleForm.validate(valid => {
        if (this.currentComponent.questionItems.length < 2) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_choiceitemmin') // 请至少设置两个选项！
          });
          return false;
        }
        if (this.currentComponent.itemAnswerObj.length > 12) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_multchoice12exceed') // 多选题不能超过12个选项
          });
          return false;
        }
        if (valid) {
          isSave = true;
        } else {
          return false;
        }
      });
      if (!isSave) {
        return { error: true };
      } else {
        // 编辑试题
        this.currentComponent.questionItems.forEach(item => {
          if (this.currentComponent.answer.includes(item.id)) {
            item.answer = 1;
          } else {
            item.answer = 0;
          }
          item.itemMultimedia = item.itemPlay;
        });
        this.currentComponent.summary = getSafeHtmlContent(this.currentComponent.content);
        this.currentComponent.error = 0;
        this.currentComponent.errorMsg = '';
        return this.currentComponent;
      }
    },
    // 获取试题基本信息
    getDetail() {
      this.$nextTick(() => {
        try {
          this.$refs['editorItem' + this.index].setHtml(
            this.currentComponent.content
          );
          this.$refs['explainText' + this.index].setHtml(
            this.currentComponent.explainText
          );
        } catch (e) {}
      });
    },
    // 删除
    delItem(index) {
      if (this.currentComponent.questionItems.length <= 2) {
        this.$message({
          type: 'warning',
          message: this.$t('pc_biz_ote_msg_choiceitemmin') // 请至少设置两个选项！
        });
        return;
      }
      const deletedItem = this.currentComponent.questionItems.splice(index, 1);

      this.currentComponent.answer = this.currentComponent.answer.filter((as) => as !== (deletedItem && deletedItem[0].id));
    },
    onCloneTarget(e) {},
    // move回调方法
    onMoveTarget(e, originalEvent) {
      const drag = e.draggedContext.index;
      const trag = e.relatedContext.index;

      const temid = this.currentComponent.questionItems[trag].orderIndex;

      this.currentComponent.questionItems[trag].orderIndex =
        this.currentComponent.questionItems[drag].orderIndex;
      this.currentComponent.questionItems[drag].orderIndex = temid;
    },
    // 右边
    // 开始拖拽事件
    onStartTarget(e) {},
    // 右边
    // 拖拽结束事件
    onEndTarget(e) {
      return false;
    },
    // 添加选项
    addItem() {
      if (this.currentComponent.questionItems.length >= 12) {
        this.$message({
          type: 'warning',
          message: this.$t('pc_biz_ote_msg_choiceitemmax') // 最多可添加12个选项！
        });
        return;
      }
      // 添加选项（单选/多选）
      const questionItem = {
        answer: 0,
        id: this.getGuid(),
        itemContent: this.$t('pc_biz_ote_lbl_defaulttopicdry')
      };
      this.currentComponent.questionItems.push(questionItem);
      this.focusIndex = this.currentComponent.questionItems.length - 1;
    }
  }
};
</script>
